/**
 * Helper functions to fetch review counts
 * These functions fetch only the count without loading all the data
 */

import { actionPointAPI } from '../Services/apiService';

/**
 * Fetch the count of items pending employee review
 * @returns {Promise<number>} The total count of items for employee review
 */
export const fetchEmployeeReviewCount = async () => {
    try {
        const response = await actionPointAPI.getEmployeeReviewCount();
        // The API returns paginated data with a 'total' field
        return response.data?.total || 0;
    } catch (error) {
        console.error('Error fetching employee review count:', error);
        return 0;
    }
};

/**
 * Fetch the count of items pending business head review
 * @returns {Promise<number>} The total count of items for business head review
 */
export const fetchBusinessHeadReviewCount = async () => {
    try {
        const response = await actionPointAPI.getBusinessHeadReviewCount();
        // The API returns paginated data with a 'total' field
        return response.data?.total || 0;
    } catch (error) {
        console.error('Error fetching business head review count:', error);
        return 0;
    }
};

/**
 * Example usage in a React component:
 * 
 * import { fetchEmployeeReviewCount, fetchBusinessHeadReviewCount } from '../utils/reviewCountHelper';
 * 
 * const MyComponent = () => {
 *   const [employeeReviewCount, setEmployeeReviewCount] = useState(0);
 *   const [businessHeadReviewCount, setBusinessHeadReviewCount] = useState(0);
 * 
 *   useEffect(() => {
 *     const loadCounts = async () => {
 *       const empCount = await fetchEmployeeReviewCount();
 *       const bhCount = await fetchBusinessHeadReviewCount();
 *       setEmployeeReviewCount(empCount);
 *       setBusinessHeadReviewCount(bhCount);
 *     };
 *     loadCounts();
 *   }, []);
 * 
 *   return (
 *     <div>
 *       <p>Employee Review Count: {employeeReviewCount}</p>
 *       <p>Business Head Review Count: {businessHeadReviewCount}</p>
 *     </div>
 *   );
 * };
 */
